import React, { Fragment, useEffect, useState } from 'react';
import { Box, Button, Tooltip, Typography } from "@mui/material";
import TableContainer from "../../../Components/TableContainer/TableContainer";
import PROFILE_PHOTO_USER from '../../../Assets/Images/Common/avtar.png'
import CustomAction from '../../../Components/CustomAction/CustomAction';
import AxiosInstance from '../../../Config/AxiosInstance';
import APILIST from '../../../Config/ApiList';
import Constant from '../../../Utils/Constant';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import AddOffer from './AddOffer';
import moment from 'moment';
const OfferManagement = () => {
  const pageSize = 30;
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [offerList, setOfferList] = useState([]);
  const [typeCheck, setTypeCheck] = useState(null);
  const [showOfferModel, setShowOfferModel] = useState(false);
  const [editOfferData, setEditOfferData] = useState(null);
  const columns = [
    { field: "rowid", headerName: "Sr.No.", minWidth: 100, },
    {
      field: "banner",
      headerName: "Banner",
      minWidth: 50,
      renderCell: (params) => {
        return (
          <img src={params?.row?.banner ? `${Constant.BASE_URL}${params?.row?.banner}` : PROFILE_PHOTO_USER} alt='profile_photo' style={{
            width: '40px',
            height: '40px',
            borderRadius: '10px'
          }} />
        )
      }
    },
    {
      field: "title",
      headerName: "Title",
      minWidth: 300,
      renderCell: (params) => (params?.row?.title ? params?.row?.title : "--")
    },
    {
      field: "link",
      headerName: "Link",
      minWidth: 400,
      renderCell: (params) => (
        <Tooltip title={params?.row?.link || "--"}>
          <span>{params?.row?.link || "--"}</span>
        </Tooltip>
      ),
    },
    {
      field: "start_time",
      headerName: "Start Time",
      minWidth: 200,
      renderCell: (params) => {
        const startDate = moment(params?.row?.start_time).utc().format('DD-MM-YYYY hh:mm:ss')
        return (
          <Tooltip title={startDate || "--"}>
            <span>{startDate || "--"}</span>
          </Tooltip>
        )
      }
    },
    {
      field: "end_time",
      headerName: "End Date",
      minWidth: 200,
      renderCell: (params) => {
        const endDate = moment(params?.row?.end_time).utc().format('DD-MM-YYYY hh:mm:ss')
        return (
          <Tooltip title={endDate || "--"}>
            <span>{endDate || "--"}</span>
          </Tooltip>
        )
      }
    },
    {
      field: "action",
      headerName: "Actions",
      flex: 1,
      minWidth: 100,
      renderCell: (params) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", gap: "2rem" }}>
            <CustomAction
              showDelete={true}
              showEdit={true}
              isEdit={() => {
                handleEditOfferModel(params?.row)
              }}
              isDelete={() => handleDeleteOffer(params?.row?.id)}
            />
          </Box>
        );
      },
    },
  ];
  useEffect(() => {
    getOfferList();
  }, [page]);
  const getOfferList = async () => {
    setIsLoading(true);
    try {
      const response = await AxiosInstance.get(APILIST.GET_OFFER, {
        params: {
          count: page * pageSize,
          offset: pageSize,
          is_admin: 1
        }
      });
      if (response && response?.data?.s) {
        const Rowdata = response?.data?.r?.map((data, i) => ({
          rowid: i + 1 + page * pageSize,
          ...data,
        }));
        console.log('Rowdata', Rowdata);

        setOfferList(Rowdata);
        setCount(response?.data?.c || 0);
      } else {
        setOfferList([]);
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setIsLoading(false);
    }
  }
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  const handleEditOfferModel = (OfferData) => {
    setTypeCheck('EDIT');
    setShowOfferModel(true);
    setEditOfferData(OfferData)
  }
  const handleOnSubmit = () => {
    setTypeCheck(null);
    getOfferList();
    setShowOfferModel(false);
  }
  const handleDeleteOffer = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Offer",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#46adf2",
      cancelButtonColor: "#5b5d5d",
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const params = {
          id: id,
          status: 0,
        };
        try {
          const response = await AxiosInstance.post(
            APILIST.DELETE_OFFER,
            params
          );
          if (response?.data?.s === 1) {
            getOfferList();
            toast.success("Offer Deleted Sucessfully !.");
          }
        } catch (error) {
          toast.error("Failed to delete Offer. Please try again.");
        }
      }
    });
  };
  return (
    <Fragment>
      <Box sx={{
        width: '100%',
        padding: '15px'
      }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            paddingBottom: '16px'
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "20px", md: "30px" },
              fontWeight: "500",
              paddingBottom: "10px",
              fontFamily: "Outfit",
            }}
          >
            Offer Management
          </Typography>
          <Button
            sx={{
              width: "120px",
              borderRadius: "15px",
              textTransform: "none",
              fontSize: "16px",
              background: "linear-gradient(180deg, #B191FF 0%, #D0BCFF 100%)",
              color: "black",
              padding: "0",
              margin: "0",
              height: '51px',
              "&:hover": {
                background: "linear-gradient(180deg, #B191FF 0%, #D0BCFF 100%)",
                color: "black",
              },
              fontFamily: "Outfit",
            }}
            onClick={() => setShowOfferModel(true)}
          >
            Add Offer
          </Button>
        </Box>
        <Box sx={{ padding: "24px 0px 24px 0px", borderTop: '1px solid #0000003D' }}>
          <Box sx={{ padding: "24px 0px 24px 0px" }}>
            <TableContainer
              rows={offerList}
              columns={columns}
              pageSize={pageSize}
              loading={isLoading}
              page={page}
              totalCount={count}
              handlePageChange={handlePageChange}
              isPagination={true}
            />
          </Box>
        </Box>
      </Box>
      <AddOffer
        open={showOfferModel}
        onClose={() => { setShowOfferModel(false); setTypeCheck(null) }}
        typeCheck={typeCheck}
        editOfferData={editOfferData}
        handleOnSubmit={handleOnSubmit}
        handleOnClose={() => { setShowOfferModel(false); setTypeCheck(null) }}
      />
    </Fragment>
  );
};

export default OfferManagement;
